module.exports = __webpack_public_path__ + "img/niigata_cycle.1df982a3.jpg";